<template>
  <div class="main-page">
    <h3>老板来隐私权保护政策</h3>
    <p>本版发布日期：2023年1月10日 </p>
    <p>生效日期：2023年1月10日</p>
    <p>杭州有云科技有限公司（以下简称“我们”，注册地址：浙江省杭州市西湖区浙大森林A幢1001-1，2室 ，联系电话：400-081-8661）非常重视您的个人信息保护，基于您个人信息及隐私安全的重要性，请您务必仔细阅读并充分理解本政策，特别是加黑加粗的条款，您应重点阅读，如您不接受本政策中的任意条款，请勿点击“同意”或进行后续操作。如您点击“同意”并确认提交，即视为您同意本隐私政策,并同意我们将按照本政策来收集、使用、存储和共享您的相关信息。</p>
    <h3>一、我们如何收集和使用您的个人信息</h3>
    <p>为了实现服务的提供，我们会基于如下需要收集、使用、共享、存储您的个人信息：</p>
    <h4>（一）APP各项业务收集使用个人信息的目的、方式和范围</h4>
    <p>为了向您提供老板来APP相关产品或服务，我们将严格依据法律法规并遵循正当、合法、必要的个人信息处理原则，在征得您的授权同意或依据其他合法性事由收集和使用您的个人信息，并根据信息敏感分类分级情况采取相应的安全技术措施。</p>
    <h5>1. 以下是老板来app各项业务的个人信息收集使用情况：</h5>
    <h5>1.1 收款技术服务</h5>
    <p>
      <span class="p-title">功能场景:</span>
      <span class="p-content">在老板来APP中使用收款功能</span>
    </p>
    <p> 
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">根据《中国人民银行关于加强支付受理终端及相关业务管理的通知》（银发〔2021〕259号）的要求</span>
    </p>
    <p>
      <span class="p-title">收集信息范围：</span>
      <span class="p-content">交易金额、商户名称、交易时间、交易类型、设备信息</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密存储与传输，对数据进行脱敏、去标识化处理，去标识化处理的信息将无法识别主体，不会将您的信息进行公开披露</span>
    </p>

     <h5>1.2 消息推送服务</h5>
    <p>
      <span class="p-title">功能场景:</span>
      <span class="p-content">在老板来APP中收款后进行消息推送</span>
    </p>
    <p> 
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">用于唯一标识设备，以便向目标设备推送消息。采集地理位置甄别推送通道，提高消息推送的区域覆盖率，通过极光SDK的推送通道，可以提高消息推送的及时性,同时通过传感器设备震动方式,提高用户消息的读取率</span>
    </p>
    <p>
      <span class="p-title">收集信息范围：</span>
      <span class="p-content">设备标识符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息、设备MAC地址、软件列表、设备序列号、android ID、传感器信息)</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密存储与传输，对数据进行脱敏、去标识化处理，去标识化处理的信息将无法识别主体，不会将您的信息进行公开披露</span>
    </p>

    <h5>1.3 账单服务</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用收入统计、到账记录、账单功能</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">向您提供日常交易、资金管理服务，方便您实时查看交易信息与经营数据</span>
    </p>
    <p>
      <span class="p-title">收集信息范围：</span>
      <span class="p-content">账户信息、交易流水、入账信息</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密存储与传输，不会将您的信息进行公开披露</span>
    </p>
    <h5>1.4 基础账号服务</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用我的功能进行账号信息维护和管理</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">在APP中展示账号基本信息</span>
    </p>
    <p>
      <span class="p-title">收集信息范围：</span>
      <span class="p-content">头像、用户名、角色（管理员、店长、多门店店长、收银员）</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密存储与传输，不会将您的信息进行公开披露。</span>
    </p>
    <h5>1.5 员工管理</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用员工管理功能</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">用于员工管理和员工收款账号开通</span>
    </p>
    <p>
      <span class="p-title">收集信息范围：</span>
      <span class="p-content">员工账号、所属门店、退款权限、业绩流水、员工姓名（可选）、员工手机号（可选）</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密存储与传输，不会将您的信息进行公开披露</span>
    </p>
    <h5>1.6 门店管理</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用商户信息-门店管理功能</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">用于门店开立和门店信息管理</span>
    </p>
    <p>
      <span class="p-title">收集信息范围：</span>
      <span class="p-content">门店名称、门店营业状态、门店电话、门店行业类目、门店地址、门店照片、门店创建时间</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密存储与传输，不会将您的信息进行公开披露</span>
    </p>
    <h5>2. 以下是老板来APP各项业务的系统权限使用情况：</h5>
    <h5>2.1 相机、相册权限</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用提交门店资料、首页收款、付款码扫描、取单码扫描、设备管理硬件绑定，头像修改功能</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">用于二维码、图片、上传资料凭证、素材</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">本机采集、可在系统设置中关闭权限。</span>
    </p>
    <h5>2.2 存储读写权限</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用收款单、收款二维码、门店二维码、语音合成、图片下载</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">将图片素材存储至外部存储、或从外部存储读取图片</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">本机采集、可在系统设置中关闭权限</span>
    </p>
    <h5>3. 以下是老板来APP各项业务的设备权限使用情况：</h5>
    <h5>3.1 唯一设备码（IP地址，SIM状态，BSSID，SSID，android_id，MAC地址、应用列表、设备序列号,传感器）</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用语音播报、账单提醒通知、服务通知、云音箱配置、登录、收款功能</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">获取用户设备的序列号,通过序列号对用户进行唯一标识,用于提供更精确的信息推送服务,通过消息震动提示,提升用户消息的读取率</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">加密传输、消息推送可在“我的”->"语音播报设置"中关闭</span>
    </p>
    <h5>3.2 蓝牙权限</h5>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">在老板来APP中使用蓝牙打印机、账单蓝牙打印、云音箱蓝牙配置功能</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的：</span>
      <span class="p-content">用于连接蓝牙打印机</span>
    </p>
    <p>
      <span class="p-title">安全技术措施：</span>
      <span class="p-content">本机采集、可在系统设置中关闭权限</span>
    </p>
    <h5>3.3 麦克风权限</h5>
    <p>
      <span class="p-title">功能场景: </span>
      <span class="p-content">在老板来app收款收到消息推送通知后,进行语音播报提醒</span>
    </p>
    <p>
      <span class="p-title">收集信息的目的:</span> 
      <span class="p-content">用于语音播报</span>
    </p>
    <p>
      <span class="p-title">安全技术措施:</span> 
      <span class="p-content">可在个人中心设置页自主开启或关闭语音播报的</span>
    </p>
    <h5>4. 以下是老板来与第三方共享个人信息：</h5>
    <h5>4.1 SDK名称：极光推送SDK</h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容：</span>
      <span class="p-content">常见设备信息（包括IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM卡 IMSI 信息、设备MAC地址、软件列表、设备序列号、传感器）</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">为您提供消息推送技术服务,为了提高推送服务准确性和成功率，追踪、排查、诊断、统计服务中的各类问题，保障产品和服务安全正常运行</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">安全加密服务器传输</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">用于服务消息、接收账单提醒、收款和语音播报。</span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接：</span>
      <a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a>
    </p>
    <h5>4.2 SDK名称：百度语音</h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容：</span>
      <span class="p-content">常见设备信息（包括IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM卡 IMSI 信息、设备MAC地址、软件列表、设备序列号）</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">为您提供在接收账单、收款和用户取消支付时的语音播报提醒业务,能够实时追踪业务操作的结果和实时交易的进展.</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">本机采集</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">用于主被扫收款和用户取消支付时的语音播报提醒功能。</span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接:</span><a href="https://ai.baidu.com/ai-doc/REFERENCE/kk3dwjg7d">https://ai.baidu.com/ai-doc/REFERENCE/kk3dwjg7d</a></p>
    <h5>4.3 SDK名称：阿里云OSS SDK </h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容 ：</span>
      <span class="p-content">网络连接信息，头像、海报、门店信息</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">为您提供CDN中上传/下载图片、文件</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">安全加密服务器传输</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">头像、门店图片上传下载 </span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接:</span>
      <a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.19720258.J_9220772140.89.47cb2c4ax8Oqld">http://terms.aliyun.com/legal-
      agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud
      201902141711_54837.html?spm=5176.19720258
      .J_9220772140.89.47cb2c4ax8Oqld</a>
    </p>
    <h5>4.4 SDK名称：阿里Weex SDK </h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容 ：</span>
      <span class="p-content">读取外置存储器、写入外置存储器,获取传感器</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">uniapp基础模块默认集成,用于渲染uniapp的nvue页面引擎</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">安全加密服务器传输</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">个人中心页面的渲染和加载</span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接:</span>
      <a href="http://doc.weex.io/zh">http://doc.weex.io/zh</a>
    </p>

    <h5>4.5 SDK名称：数字天堂SDK </h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容 ：</span>
      <span class="p-content">设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息,）、写入外置存储器、设备传感器信息手势控制</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">uniapp核心模块,应用运行引擎,存储app的应用数据</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">安全加密服务器传输</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">订单号长按复制到剪切板,便于用户快速查询订单</span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接:</span>
      <a href="https://tongji.dcloud.net.cn/policy">https://tongji.dcloud.net.cn/policy</a>
    </p>


    <h5>4.6 SDK名称：fresco图片库 </h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容 ：</span>
      <span class="p-content">读取外置存储器、写入外置存储器</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">uniapp基础模块默认集成,用于nvue页面加载图片使用</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">安全加密服务器传输</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">个人中心页面图片的渲染和加载</span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接:</span>
      <a href="https://www.fresco-cn.org/">https://www.fresco-cn.org/</a>
    </p>

    <h5>4.7 SDK名称：glide图库 </h5>
    <p>
      <span class="p-title">获取并共享的个人信息内容 ：</span>
      <span class="p-content">读取外置存储器、写入外置存储器</span>
    </p>
    <p>
      <span class="p-title">使用目的：</span>
      <span class="p-content">用于图片预览</span>
    </p>
    <p>
      <span class="p-title">处理方式：</span>
      <span class="p-content">安全加密服务器传输</span>
    </p>
    <p>
      <span class="p-title">功能场景：</span>
      <span class="p-content">查看门店列表图片的预览大图</span>
    </p>
    <p>
      <span class="p-title">隐私权政策链接:</span>
      <a href="http://bumptech.github.io/glide/">http://bumptech.github.io/glide/</a>
    </p>
    <h5>我们的产品基于DCloud uni-app(5+ App/Wap2App)开发，应用运行期间需要收集您的设备唯一识别码（IMEI/android ID/DEVICE_ID/IDFA、SIM 卡 IMSI 信息、OAID）以提供统计分析服务，并通过应用启动数据及异常错误日志分析改进性能和用户体验，为用户提供更好的服务。</h5>
    <h4>（二）我们收集您的个人信息的情形</h4>
    <h5>在您使用我们的服务时，我们将根据国家法律法规、《网络安全法》、《反洗钱法》、《银行卡组织和资金清算中心反洗钱和反恐怖融资指引》等监管要求，收集和使用您的特定个人信息。</h5>
    <h5>1. 根据法律法规及监管要求，履行实名制管理与反洗钱义务</h5>
    <p>当您注册老板来商户时，您需要提供手机号作为您的有效联系方式，如您不提供前述信息，可能无法注册成为老板来的商户。根据相关法律法规的规定及监管的要求，您需要提供下述信息以完成身份认证：</p>
    <p> （1）如果您为个人用户，您需要提供姓名、有效身份证正反面照片、收款银行卡号；</p>
    <p> （2）如果您是企业用户，您需要提供：营业执照影印件、法定代表人或相应机构负责人身份证正反面照片、企业委托人（可选）姓名、身份证号及身份正反面照片、企业委托授权书、企业银行账户名称、账号、开户行。</p>
    <p>如您未能提供前述个人信息，则可能无法成功注册我们APP账户或使用关联银行卡服务。</p>
    <h4>（三）向您提供支付信息技术服务，而使用您提交以及您需要提供我们收集的个人信息</h4>
    <p>1.二维码收款： 在二维码收款功能使用中，为开通收款功能，您需要提供姓名、地址、手机号、有效身份证件类型及证件号、银行卡号进行个人的实名认证，为向您提供相关服务，我们会与发卡银行就您的银行卡号、交易金额、商户名称、交易时间、交易类型进行相应的交互和处理，以实现交易处理的目的。</p>
    <p>2.支付服务：您在办理某些业务时，可能需要使用支付服务以完成交易。在您使用支付业务过程中，我们可能会获取您的姓名、身份证号、开户银行、银行卡号、收款人的老板来App商户名称及账号、收款人手机号。</p>
    <p>3.查询服务：为了向您提供日常交易、资金管理服务，方便您实时查看交易信息与经营数据，根据第三方支付公司的接口，我们展示您的账户信息、交易流水及入账信息。</p>
    <p>4.其他业务：我们将会不断更新服务，基于该服务，我们需要收集、使用您的信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或某部分服务，但不影响您使用我们提供的其他服务。</p>
    <p>5.为了保障您的交易安全，我们会在服务开通、启动App、收款、提现场景使用您的地理位置信息。为了使App可稳定运行不被恶意应用干扰，我们需要应用安装列表权限，以保障您的信息及资金安全。</p>
    <p>6.为方便您及时掌握系统通知、账单通知、手机设备收款语音播报服务，您可以在安装APP时授权我们允许通知、应用自启动及关联启动的权限，以便于您及时知晓系统通知、到账通知。</p>
    <p>7.密码找回：为保障您的账户与资金安全，在您需要找回密码时，您需要提供可用于证实您身份的注册手机号或用户名、已绑定银行卡号、姓名、有效身份证件类型及证件号、银行预留手机号。</p>
    <h4>（四）安全管理</h4>
    <p>为尽最大努力保障您的账户与交易安全，我们会收集您使用我们app服务的相关操作信息，包括您的硬件设备型号、软件版本信息、IP地址、位置信息、移动网络信息、标准网络日志数据以进行相应的安全校验。在您未提供前述信息的情况下，可能无法完成安全核验。</p>
    <h4>（五）安全运行与风控验证</h4>
    <p>为了保障软件与服务的安全运行，防止您的个人信息被非法获取，更准确地预防欺诈和保护账号安全，我们会收集您的 设备信息【包括：设备型号、设备名称、SIM卡序列号、设备唯一标识符（包括：IMEI、IMSI、AndroidID、IDFA、OAID、SSID）】、存储（相册、媒体和其他文件）、浏览器类型和设置、语言设置、操作系统和软件安装列表、网络设备硬件地址（MAC地址）、登录IP地址、接入网络的方式、网络质量数据、移动网络信息（包括运营商名称）、产品版本号以及应用列表、软件使用记录信息，如您不同意我们收集前述信息，可能无法完成风控验证。请您理解，为动态检测您的账户是否存在异常登录，每次您把老板来APP切换至后台或重新启动程序时，我们可能会再次读取，我们将把读取频次控制在合理范围内。</p>
    <h4>（六）您使用我们服务时，我们系统将通过SDK或其他方式采集以下信息与三方进行共享：</h4>
    <p>1.日志信息：如果您已安装我们的app软件，我们会读取您的移动设备属性及其存储信息，包括您使用硬件设备的品牌及型号、设备的识别码IMEI、操作系统及软件版本、位置信息、IMSI/android、openUDID/iOS、SIM卡序列号、MAC地址、所在国家或地区、您的手机号码。</p>
    <p><span>2.消息推送服务：老板来服务消息通知推送、语音播报功能由极光平台提供推送技术服务，我们会将您的设备平台、设备厂商、设备品牌、设备识别码设备信息，应用列表信息、网络信息系以及位置相关信息提供给每日互动股份有限公司进行链路调节，相互促活被关闭的SDK推送进程，保障您可以及时接收到我们向您推送的消息，推送服务详细内容请访问《极光推送用户隐私政策》链接：</span><a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></p>
    <p><span>3.为了使用阿里云OSS CDN 上传/下载图片,我们集成了阿里云OSS SDK，我们会收集网络连接信息，头像、门店信息。 隐私权政策链接：</span><a href="http://terms.aliyun.com/legal-agreement/terms/
    suit_bu1_ali_cloud/suit_bu1_ali_cloud201902141711_54837.html?spm=5176.19720258.J_9220772140.89.47cb2c4ax8Oqld">http://terms.aliyun.com/legal-
    agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud
    201902141711_54837.html?spm=5176.19720258
    .J_9220772140.89.47cb2c4ax8Oqld</a></p>
    <p>4.以上信息App涉及的用户信息使用SDK相关情况逐项列举，可以在以下附件中查阅。附件：老板来App个人信息收集和第三方共享个人信息清单您也可以在APP中通过进入系统设置来查阅《隐私权保护政策》。</p>
    <h4>（七）您可选择是否授权我们收集和使用您的个人信息的情形</h4>
    <p>1.为向您提供更便捷的二维码支付功能，您可以在第一次使用上诉功能时授权我们访问您的摄像头（相机）时授权我们访问您的相机设备。如果您不提供这些个人信息，您可能无法使用上述服务，但不影响您使用我们提供的其他服务</p>
    <p>2.为向您提供更便捷的PC控台登录服务，您可以在第一次使用上述功能时授权我们访问您的摄像头（相机）时授权我们访问您的相机设备。如果您不提供这些个人信息，您可能无法使用上述服务，但不影响您使用我们提供的其他服务。</p>
    <p>3.为方便您及时掌握系统通知、账单通知、手机设备收款语音播报服务，您可以在安装APP时授权我们允许通知、应用自启动及关联启动的权限，如果您不提供这些个人信息，您可能无法使用上述服务，但不影响您使用我们提供的其他服务。</p>
    <p>4.为向您提供收款、绑定收款设备服务，您可以在第一次使用上述功能时授权我们访问您的蓝牙权限。如果您不提供这些个人信息，您可能无法使用上述服务，但不影响您使用我们提供的其他服务。</p>
    <p>5.为保障客户端的稳定运行和保障您的支付服务安全，您可以在安装我们APP时授权我们可读取/写入您的设备存储权限、设备IMSI信息、手机状态及定位权限，我们将自您设备存储空间内读取或向其中写入图片、文件、应用信息数据文件缓存、崩溃日志信息等必要信息，用于向您提供信息发布或在本地记录崩溃日志信息的功能</p>
    <h3>二、信息的使用规则</h3>
    <p>（一）我们承诺我们将使信息安全保护达到行业领先的安全水平。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来尽量降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。同时我们设立了个人信息保护责任部门，建立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。</p>
    <p>（二）我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以APP推送通知、发送邮件/短消息等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
    <p>（三）**请您务必妥善保管好您的登录名及其他身份要素。您在使用服务时，我们会通过您的登录名及其他身份要素来识别您的身份。一旦您泄漏了前述信息，您可能会蒙受损失，并可能产生对您不利的法律后果。**如您发现登录名及/或其他身份要素可能或已经泄露时，请您立即和我们取得联系，以便我们及时采取相应措施以避免或降低相关损失。</p>
    <h3>三、信息的使用</h3>
    <p>（一）**我们承诺对您的信息进行保密。除法律法规及监管部门另有规定外，我们仅在以下情形中与第三方共享您的信息，第三方包括我们的关联公司、合作金融机构以及其他合作伙伴。在将信息提供给第三方前，我们将尽商业上合理的努力评估该第三方收集信息的合法性、正当性、必要性。**我们会与第三方签订相关法律文件并要求第三方处理您的个人信息时遵守法律法规，尽力要求第三方对您的信息采取保护措施。</p>
    <h5>（二）在收集您的个人信息后，我们将通过技术手段对数据进行脱敏、去标识化处理，去标识化处理的信息将无法识别主体。</h5>
    <h5>（三）为了让您完成交易、实现交易目的，以及根据监管要求，我们需要向您的支付服务提供方提供交易号与相关支付信息，或者某些产品或服务可能由第三方提供或由我们与第三方共同提供，因此，只有共享您的姓名、身份证、手机号、银行卡号信息，才能提供您需要的产品或服务。</h5>
    <h5>（四）原则上我们不会将您的信息进行公开披露。如确需公开披露时，我们会向您告知公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的同意。</h5>
    <h5>（五）我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</h5>
    <p> 1. 事先获得您的明确同意；</p>
    <p> 2. 根据法律法规或强制性的行政或司法要求；</p>
    <p> 3. 在涉及资产转让、收购、兼并、重组或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受本政策的约束。如变更个人信息使用目的时，我们将要求该公司、组织重新取得您的明确同意。</p>
    <h3>四、信息的存储</h3>
    <p>（一）存储地点：我们在中华人民共和国境内运营中收集和产生的个人信息，将存储在中国境内。我们仅在本政策所述目的所必须期间和法律法规及监管规定的时限内保存您的个人信息。</p>
    <p>（二）存储期限：我们会采取合理可行的措施，尽力避免收集和处理无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的留存要求。 例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息自交易完成之日起不少于三年。我们判断个人信息的存储期限主要参考以下标准并以其中较长者为准：</p>
    <h5> 1.完成与您相关的交易目的、维护相应交易及业务记录，以应对您可能的查询或投诉；</h5>
    <h5> 2.保证我们为您提供服务的安全和质量；</h5>
    <h5> 3.您是否同意更长的留存期间</h5>
    <h5> 4.是否存在保留期限的其他特别约定。</h5>
    <h5>在超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。</h5>
    <h3>五、外部链接</h3>
    <h5>请您注意，您的交易相对方、您访问的第三方网站经营者、通过我们接入的第三方服务和由老板来处接收您的个人信息的第三方可能有自己的隐私权保护政策；当您查看第三方创建的网页或使用第三方开发的应用程序时，这些第三方可能会放置他们自己的Cookie或像素标签，这些Cookie或像素标签不受我们的控制，且它们的使用不受本政策的约束。<p> 我们会尽商业上的合理努力去要求这些主体对您的个人信息采取保护措施，但我们无法保证这些主体一定会按照我们的要求采取保护措施，请您与他们直接联系以获得关于他们的隐私权政策的详细情况。如您发现这些第三方创建的网页或第三方开发的应用程序存在风险时，建议您终止相关操作以保护您的合法权益。</p></h5>
    <h3>六、政策更新</h3>
    <p>（一）老板来所有服务均适用本政策。</p>
    <p>（二）发生下列重大变化情形时，我们会适时对本政策进行更新：</p>
    <p> （1）我们的基本情况发生变化，例如：兼并、收购、重组引起的所有者变</p>
    <p> （2）收集、存储、使用个人信息的范围、目的、规则发生变化；</p>
    <p> （3）对外提供个人信息的对象、范围、目的发生变化</p>
    <p> （4）您访问和管理个人信息的方式发生变化</p>
    <p> （5）数据安全能力、信息安全风险发生变化</p>
    <p> （6）用户询问、投诉的渠道和机制，以及外部纠纷解决机构及联络方式发生变化；</p>
    <p> （7）其他可能对您的个人信息权益产生重大影响的变化。</p>
    <h5>（三）由于老板来的用户较多，如本政策发生更新，我们将以APP推送通知、发送邮件/短消息或者在有云官方网站发布公告的方式来通知您。为了您能及时接收到通知，建议您在联系方式更新时及时通知我们。未经您明确同意，我们不会限制您按照当前生效的本政策应享受的权利</h5>
    <h3>七、用户信息管理及申诉</h3>
    <p>（一）在您使用老板来商户服务期间，为了您可以更加便捷地访问和管理您的信息，同时保障您注销账户的权利，我们在客户端中为您提供了相应的操作设置，您可以参考下面的指引进行操作管理您的信息。</p>
    <h5>（二）您可通过老板来商户APP登录老板来商户账户，在“我的-设置”中查询您的个人信息；在“我的-设置-安全管理”中进行修改账号、修改密码等操作。</h5>
    <h5>（三）您可通过老板来APP登录老板来商户账户，在“我的-设置-联系我们”中反馈您的意见或疑问；也可以根据提供的客服联系方式直接联系我们,我们会竭诚为您服务。</h5>
    <h5>（四）如您需要对您的账号进行注销,请联系我们的运营人员在线帮您进行操作,联系电话15658156835,我们会在2~3个工作日内帮您核实并完成账号的注销</h5>
    <p>（五）如您想改变授权范围，您可通过拨打我们的助手热线15658156835的方式联系我们，我们将在十五个工作日内完成核查或处理。</p>
    <p>（六）如您对本政策存在任何疑问，或对于您的个人信息处理存在任何投诉、意见，请通过拨打客诉热线15658156835的方式联系我们。为保障您的信息安全，我们需要先验证您的身份和凭证材料。我们已经建立客户投诉管理机制，客诉在接到您的投诉或意见后将在十五个工作日内完成核查或处理。</p>

  </div>
</template>

<script>
  export default {
    name: 'FirePrivacy',
    data () {
      return {
     
      }
    },
    created () {
      document.title = '隐私协议'
    }
  }
</script>

<style>
  .main-page {
    width: 100%;
  }
  p {
    text-align: left;
    font-size: 14px;
  }
  h3 {
    text-align: left;
  }
  h4 {
    text-align: left;
  }
  h5 {
    text-align: left;
  }
  .p-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
  }
  .p-title {
    font-size: 14px;
    font-weight: 500;
    color: #333333;
    text-align: left;
  }
  .p-content {
    font-size: 13px;
    color: #333333;
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/BossComePrivacy.vue